export const SLIDER_ADD = 'SLIDER:ADD';
export const SLIDER_MOVE = 'SLIDER:MOVE';
export const SLIDER_MOVE_LEFT = 'SLIDER:MOVE_LEFT';
export const SLIDER_MOVE_RIGHT = 'SLIDER:MOVE_RIGHT';
export const SLIDER_SET_MIRROR_MODE = 'SLIDER:SET_MIRROR_MODE';

export const addSlider = ({ slidesCount = 0, activeSlide = 0, prevSlide = slidesCount - 1 }) => ({
    type: SLIDER_ADD,
    payload: {
        prevSlide,
        activeSlide,
        slidesCount,
        direction: 'right'
    }
});

export const sliderMove = ({ prevSlide, activeSlide }) => ({
    type: SLIDER_MOVE,
    payload: {
        prevSlide,
        activeSlide
    }
});

export const sliderMoveLeft = () => ({
    type: SLIDER_MOVE_LEFT,
    isSilent: true
});

export const sliderMoveRight = () => ({
    type: SLIDER_MOVE_RIGHT,
    isSilent: true
});

export const setIsMirrorMode = (isMirrorMode) => ({
    type: SLIDER_SET_MIRROR_MODE,
    isMirrorMode,
    isSilent: true
});
